export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ""}/service-worker.js`);
      window.__boOnlineSwRegistration = registration;
      const announce = () => window.dispatchEvent(new CustomEvent("boonline:pwa-update"));
      if (registration.waiting && navigator.serviceWorker.controller) announce();
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) announce();
        });
      });
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.dispatchEvent(new CustomEvent("boonline:pwa-controller-change"));
      });
      window.setInterval(() => registration.update().catch(() => undefined), 60 * 60 * 1000);
    } catch (error) {
      console.error("PWA service worker registration failed:", error);
    }
  });
}
